import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ListFormsPage.css'; // Make sure this import is correct
import { useNavigate } from 'react-router-dom';
import { baseUrl } from '../utils/config';

const ListFormsPage = () => {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState(''); // NEW: State for search query
  const navigate = useNavigate();

  const fetchForms = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${baseUrl}/api/form-templates`);
      setForms(response.data);
    } catch (err) {
      console.error("Error fetching forms:", err);
      setError("Failed to load forms. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchForms();
  }, []);

  const handleEdit = (formId) => {
    navigate(`/dashboard/form-management/edit/${formId}`); // Use the absolute path
  };

  const handleDelete = async (formId, formName) => {
    if (window.confirm(`Are you sure you want to delete the form: "${formName}"?`)) {
      try {
        await axios.delete(`${baseUrl}/api/form-templates/${formId}`);
        alert('Form deleted successfully!');
        fetchForms(); // Re-fetch the list to show the updated state
      } catch (err) {
        console.error("Error deleting form:", err);
        setError("Failed to delete form. Please try again.");
        if (err.response && err.response.status === 404) {
          setError("Form not found.");
        }
      }
    }
  };

  // NEW: Filter the forms based on searchTerm
  const filteredForms = forms.filter(form => {
    // Convert both form name and search term to lowercase for case-insensitive search
    const formName = form.formName ? form.formName.toLowerCase() : '';
    const fileName = form.fileName ? form.fileName.toLowerCase() : '';
    const searchLower = searchTerm.toLowerCase();

    return formName.includes(searchLower) || fileName.includes(searchLower);
  });

  return (
    <div className="list-forms-page-container">
      <h1 className="page-title">List of Saved Template Forms</h1>

      {/* NEW: Search bar section - Placed directly above the list content */}
      <div className="search-bar-section">
        <input
          type="text"
          placeholder="Search forms..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>

      {/* Main content section - the white card with the table */}
      <div className="list-forms-content">
        {loading && <p className="loading-message">Loading forms...</p>}
        {error && <p className="error-message">{error}</p>}

        {!loading && !error && filteredForms.length === 0 && ( // Use filteredForms here
          <p className="no-forms-message">
            {searchTerm ? "No matching forms found." : "No forms found. Start by adding one!"}
          </p>
        )}

        {!loading && !error && filteredForms.length > 0 && ( // Use filteredForms here
          <table className="forms-table">
            <thead>
              <tr>
                <th>Sl. No.</th>
                <th>Form Name</th>
                <th>Original File Name</th>
                <th className="actions-header">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredForms.map((form, index) => ( // Iterate over filteredForms
                <tr key={form._id}>
                  <td>{index + 1}</td>
                  <td>{form.formName}</td>
                  <td>{form.fileName}</td>
                  <td className="actions-cell">
                    <button
                      className="action-button edit-button"
                      onClick={() => handleEdit(form._id)}
                      title="Edit Form"
                    >
                      <span className="icon">✏️</span> <span className="text">Edit</span>
                    </button>
                    <button
                      className="action-button delete-button"
                      onClick={() => handleDelete(form._id, form.formName)}
                      title="Delete Form"
                    >
                      <span className="icon">🗑️</span> <span className="text">Delete</span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default ListFormsPage;